import React from "react";
import { renderContent } from "../../helper";

const App = text => (
  <div
    className="comment-item-content"
    dangerouslySetInnerHTML={{
      __html: renderContent(text)
    }}
  />
);

export default App;
